<div class="card" *ngIf='displayState.workingDiv'>
  <div class="card-body">
      <div class="row" >
          <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
      </div>
      <div class="row">
          <div class="col-md-2 offset-5">
              <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
          </div>
      </div>
  </div>
</div>
<div *ngIf='displayState.detailsDiv'>
    <div class="row" style="margin-bottom: 5px;">
        <div class="col-md-2 offset-1">
            <label for="caseNum" class="col-form-label prd-label">APN</label>
            <input id="caseNum" type="text" class="form-control" value="{{ myProperty.parcelNumber }}">
        </div>
        <div class="col-md-3">
            <label for="userName" class="col-form-label prd-label">User Name</label>
            <input id="userName" type="text" class="form-control" value="{{myApplication.userName}}">
        </div>
        <div class="col-md-2">
            <label for="appLastName" class="col-form-label prd-label">Name of Applicant</label>
            <input id="appLastName" type="text" class="form-control" value="{{myApplicant.fullName}}">
        </div>
        <div *ngIf='myApplication.caseNumber' class="col-md-2">
            <label for="caseNum" class="col-form-label prd-label">Case #</label>
            <input id="caseNum" type="text" class="form-control" value="{{ myApplication.caseNumber}}">
        </div>
</div>
    <hr />
    <div class="row" style="margin-bottom: 5px;">
    <div class="col-md-2 offset-1">
        <button class="btn btn-sm btn-link" (click) = "openAllSections()">Open all Sections</button>    
    </div>
    <div class="col-md-2">
        <button class="btn btn-sm btn-link" (click) = "closeAllSections()">Close all Sections</button>    
    </div>
    <div class="col-md-2">
        <button class="btn btn-sm btn-link" (click) = "validateApp()" title="Verify application contains valid and complete data for submission">Validate</button>    
    </div>
    <br />
    <div class="col-md-2 offset-2">
        <button class="btn btn-success" (click)="exitDetails()">Exit Details</button>
    </div>
    </div>

    <div class="form-row">
        <div class="col-md-10 offset-1">
            <p-accordion [multiple]="true" [activeIndex]="accordionOpenIndex">
                <p-accordionTab header="Applicant">
                    <div class="form-row">
                        <div class="col-md-5">
                            <label for="firstName" class="col-form-label prd-label">FIRST</label>
                            <input id="firstName" type="text" class="form-control" [(ngModel)]="myApplicant.firstName">
                        </div>
                        <div class="col-md-2">
                            <label for="mi" class="col-form-label prd-label">MI</label>
                            <input id="mi" type="text" class="form-control" [(ngModel)]="myApplicant.middleInitial">
                        </div>
                        <div class="col-md-5">
                            <label for="lastName" class="col-form-label prd-label">LAST name of Applicant (or Business or Trust Name)</label>
                            <input id="lastName" type="text" class="form-control" [(ngModel)]="myApplicant.lastName">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-5">
                            <label for="email" class="col-form-label prd-label">E-Mail Address</label>
                            <input id="email" type="text" class="form-control" [(ngModel)]="myApplicant.email">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-10">
                            <label for="mailAddr" class="col-form-label prd-label">Mailing Address (Street Address or PO)</label>
                            <input id="mailAddr" type="text" class="form-control" [(ngModel)]="myApplicant.mailingAddress">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-4">
                            <label for="city" class="col-form-label prd-label">City</label>
                            <input id="city" type="text" class="form-control" [(ngModel)]="myApplicant.city">
                        </div>
                        <div class="col-md-1">
                            <label for="state" class="col-form-label prd-label">State</label>
                            <input id="state" type="text" class="form-control" [(ngModel)]="myApplicant.state">
                        </div>
                        <div class="col-md-2">
                            <label for="zipcode" class="col-form-label prd-label">Zip</label>
                            <input id="zipcode" type="text" class="form-control" [(ngModel)]="myApplicant.zipcode">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-4">
                            <label for="dayPhone" class="col-form-label prd-label">Daytime Phone</label>
                            <input id="dayPhone" type="text" class="form-control" [(ngModel)]="myApplicant.dayPhone">
                        </div>
                        <div class="col-md-4">
                            <label for="altPhone" class="col-form-label prd-label">Alternate Phone</label>
                            <input id="altPhone" type="text" class="form-control" [(ngModel)]="myApplicant.altPhone">
                        </div>
                        <div class="col-md-4">
                            <label for="faxPhone" class="col-form-label prd-label">Fax Phone</label>
                            <input id="faxPhone" type="text" class="form-control" [(ngModel)]="myApplicant.faxPhone">
                        </div>
                    </div>

                </p-accordionTab>
                <p-accordionTab header="Agent">
                    <div class="form-row">
                        <div class="col-md-5">
                            <label class="col-form-label prd-label">FIRST</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.firstName">
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label prd-label">MI</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.middleInitial">
                        </div>
                        <div class="col-md-5">
                            <label class="col-form-label prd-label">LAST name of Agent, Attorney or Relative</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.lastName">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <label class="col-form-label prd-label">E-Mail Address</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.email">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-10">
                            <label class="col-form-label prd-label">Company Name</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.companyName">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-10">
                            <label class="col-form-label prd-label">Contact Person if Other than Above (LAST, FIRST, MIDDLE INITIAL)</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.contactPerson">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-10">
                            <label class="col-form-label prd-label">Mailing Address (Street Address or PO)</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.mailingAddress">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">City</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.city">
                        </div>
                        <div class="col-md-1">
                            <label class="col-form-label prd-label">State</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.state">
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label prd-label">Zip</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.zipcode">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Daytime Phone</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.dayPhone">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Alternate Phone</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.altPhone">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Fax Phone</label>
                            <input type="text" class="form-control" [(ngModel)]="myAgency.faxPhone">
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="Property">
                    <div class="form-row">
                        <div class="col-md-12" >
                            <label class="col-form-label prd-label">Is this property a single-family dwelling that is occupied as the principal place of residence by the owner?</label>
                            <select style="width:80px; margin-left: 10px;" [(ngModel)]="myProperty.isSingleFamilyPrincipalResidence">
                                <option></option>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>

                        </div>
                    </div>
                    <br />
                    <div class="form-row">
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Assessor's Parcel Number</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.parcelNumber">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Assessment Number</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.assessmentNumber">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Fee Number</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.feeNumber">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Account Number</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.accountNumber">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Tax Bill Number</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.taxBillNumber">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-2">
                            <label class="col-form-label prd-label">Street Number</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.streetNumber">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Street Name</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.streetAddress">
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label prd-label">Unit</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.unit">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">City</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.city">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-8">
                            <label class="col-form-label prd-label">Property Description or Location (if applicable)</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.addressOrLocation">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label">Doing Business As (DBA) if appropriate</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.dba">
                        </div>
                    </div>
                    <br />
                    <div class="form-row">
                        <div class="col-md-6">
                            <label class="col-form-label prd-label">Property Type</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.propertyType">
                        </div>
                        <div class="col-md-4" *ngIf="myProperty.propertyType === 'Other'">
                            <label class="col-form-label prd-label">Other Type</label>
                            <input type="text" class="form-control" [(ngModel)]="myProperty.otherTypeDescription">
                        </div>
                    </div>

                </p-accordionTab>
                <p-accordionTab header="Value">
                    <div class="row">
                        <div class="col-md-8">
                            <table class="table table-condensed">
                                <tr>
                                    <td class="col-form-label prd-label" style="width: 44%"></td>
                                    <td class="col-form-label prd-label" style="width: 28%">A. Value on Roll</td>
                                    <td class="col-form-label prd-label" style="width: 28%">B. Applicant's Opinion of Value</td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">LAND</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.land | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.land | number }}">
                                    </td>
                                </tr>

                                <tr>
                                    <td class="col-form-label prd-label">IMPROVEMENTS/STRUCTURES</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.improvements | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.improvements | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">FIXTURES</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.fixtures | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.fixtures | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">PERSONAL PROPERTY (see instructions)</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.personalProperty | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.personalProperty | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">MINERAL RIGHTS</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.mineralRights | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.mineralRights | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">TREES AND VINES</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.treesAndVines | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.treesAndVines | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">OTHER</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.other | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.other | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label" style="text-align: right">
                                        <input type="checkbox" style="text-align: left;" [(ngModel)]="myApplication.hasEnteredTotals">
                                        <label class="info-large">Allow manual entry of Totals</label>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.totalRollValues | number }}">
                                    </td>
                                    <td>
                                        <input id="opinionTotal" type="text" class="form-control text-right" value="{{myOpinionValues.totalOpinionValues | number }}">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-form-label prd-label">PENALTIES (amount or percent)</td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myRollValues.penalties | number }}">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control text-right" value="{{myOpinionValues.penalties | number }}">
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-5">
                            <label class="col-form-label prd-label">Type of Assessment being appealed</label>
                            <select [(ngModel)]="myAssessment.typeOfAssessmentId">
                                <option></option>
                                <option value="1">Regular Assessment - Value as of Jan 1 of the current year</option>
                                <option value="2">Supplemental Assessment</option>
                                <option value="3">Roll Change</option>
                                <option value="4">Escape Assessment</option>
                                <option value="5">Calamity Reassessment</option>
                                <option value="6">Penalty Assessment</option>
                            </select>
                        </div>
                        <div class="col-md-3" *ngIf="showAddFields()">
                            <label class="col-form-label prd-label">Date of Notice</label>
                            <input type="text" class="form-control" value="{{ myAssessment.dateOfNotice | date:'MM/dd/y'}}">
                        </div>
                        <div class="col-md-2" *ngIf="showAddFields()">
                            <label class="col-form-label prd-label">Roll Year</label>
                            <input type="text" class="form-control" [(ngModel)]="myAssessment.rollYear">
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="Facts">
                    <div class="row">
                        <div class="col-md-10 offset-1">
                            <table class="table">
                                <tr class="row">
                                    <td class="col-form-label prd-label-left">A. DECLINE IN VALUE</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.declineInValue" />
                                        <label style="border: hidden; font-weight:normal">&nbsp; The assessor's roll value exceeds the market value as of January 1 of the current year.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">B. CHANGE IN OWNERSHIP</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-8">
                                        <input type="checkbox" [(ngModel)]="myFacts.noChangeInOwnership" />
                                        <label style="border: hidden;font-weight:normal">&nbsp; 1. No change in ownership occurred on the date of</label>
                                    </td>
                                    <td class="col-md-2">
                                        <input type="text" class="form-control" value="{{ myFacts.noChangeInOwnershipDate | date:'MM/dd/y'}}"/>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-8">
                                        <input type="checkbox" [(ngModel)]="myFacts.cioBaseYearValueIncorrect" />
                                        <label style="border: hidden;font-weight:normal">&nbsp; 2. Base year value is incorrect for the change in ownership established on the date of</label>
                                    </td>
                                    <td class="col-md-2">
                                        <input type="text" class="form-control" value="{{ myFacts.cioBaseYearValueIncorrectDate | date: 'MM/dd/y'}}"/>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">C. NEW CONSTRUCTION</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-8">
                                        <input type="checkbox" [(ngModel)]="myFacts.noNewConstruction" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; 1. No new construction occurred on the date of</label>
                                    </td>
                                    <td class="col-md-2">
                                        <input type="text" class="form-control" value="{{myFacts.noNewConstructionDate | date: 'MM/dd/y'}}"/>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-8">
                                        <input type="checkbox" [(ngModel)]="myFacts.ncBaseYearValueIncorrect" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; 2. Base year value is incorrect for the completed new construction established on the date of</label>
                                    </td>
                                    <td class="col-md-2">
                                        <input type="text" class="form-control" value="{{myFacts.ncBaseYearValueIncorrectDate | date: 'MM/dd/y'}}"/>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.ncValueOfConstructionIncorrect" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; 3. Value of construction in progress on January 1 is incorrect.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">D. CALAMITY REASSESSMENT</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.calamityReassessment" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Assessor's reduced value is incorrect for property damaged by misfortune or calamity.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">E. BUSINESS PERSONAL PROPERTY/FIXTURES</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.businessPersonalPropFixtures" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; 1. All personal property/fixtures.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.businessPersonalPropPartial" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; 2. Only a portion of the personal property/fixtures.</label>
                                    </td>
                                </tr>
                                <tr class="row" *ngIf="myFacts.businessPersonalPropPartial">
                                    <td class="col-md-10">
                                        <textarea title="Describe the personal property/fixture items." style="width: 600px; height: 120px" [(ngModel)]="myFacts.businessPersonalPropPartialDesc"></textarea>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">F. PENALTY ASSESSMENT</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.penaltyAssessment" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Penalty assessment is not justified.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">G. CLASSIFICATION/ALLOCATION</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.propertyClassification" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Classification of property is incorrect.</label>
                                    </td>
                                </tr>
                                <tr class="row">

                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.propertyAllocation" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Allocation of value of property is incorrect (e.g. between land and improvements).</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">H. APPEAL AFTER AN AUDIT</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.amountOfEscapeAssessment" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Amount of escape assessment is incorrect.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.assessmentOfOtherProperty" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Assessment of other property of the assessee at the location is incorrect.</label>
                                    </td>
                                </tr>
                                <tr class="row">
                                    <td class="col-form-label prd-label-left col-md-10">I. OTHER</td>
                                </tr>
                                <tr class="row">
                                    <td class="col-md-10">
                                        <input type="checkbox" [(ngModel)]="myFacts.other" />
                                        <label style="border: hidden; font-weight: normal">&nbsp; Explanation.</label>
                                    </td>
                                </tr>
                                <tr class="row" *ngIf="myFacts.other">
                                    <td class="col-md-10">
                                        <textarea id="otherDesc" title="Explanation Details" style="width: 600px; height: 120px" [(ngModel)]="myFacts.otherDesc" maxlength="500"></textarea>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="Findings">
                    <div class="row">
                        <div class="col-md-10">
                            <label class="col-form-label prd-label">Written Findings of Facts ($150.00 per Appraisal Unit )</label>
                            <select style="width: 200px; margin-left: 10px;" [(ngModel)]="myApplication.areFindingsRequested">
                                <option></option>
                                <option value="true">Are requested</option>
                                <option value="false">Are NOT requested</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="col-form-label prd-label">This application is designated as a claim refund (see instructions)?</label>
                            <select style="width: 80px; margin-left: 10px;" [(ngModel)]="myApplication.isClaimForRefund">
                                <option></option>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="Certification">
                    <div class="row">
                        <div class="col-md-7">
                            <label class="col-form-label prd-label-left">Your Name</label>
                            <input type="text" class="form-control" [(ngModel)]="myCertification.filerName">
                        </div>
                        <div class="col-md-4">
                            <label class="col-form-label prd-label-left">State Bar Number (if applicable)</label>
                            <input type="text" class="form-control" [(ngModel)]="myCertification.stateBarNumber" />
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-4">
                            <label class="col-form-label prd-label-left">Signed at City</label>
                            <input type="text" class="form-control" [(ngModel)]="myCertification.signedAtCity">
                        </div>
                        <div class="col-md-1">
                            <label class="col-form-label prd-label-left">State</label>
                            <input type="text" class="form-control" [(ngModel)]="myCertification.signedAtState">
                        </div>
                        <div class="form-group col-md-2" hidden>      
                            <label class="col-form-label prd-label-left">Date</label>
                            <input type="text" class="form-control" [(ngModel)]="myCertification.dateSigned" />
                        </div>

                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <label class="col-form-label prd-label-left">Filing Status (Identify Relationship to Applicant named in Section 1)</label>
                            <select [(ngModel)]="myCertification.filingStatus">
                                <option></option>
                                <option>Owner</option>
                                <option>Agent</option>
                                <option>Attorney</option>
                                <option>Spouse</option>
                                <option>Registered Domestic Partner</option>
                                <option>Child</option>
                                <option>Parent</option>
                                <option>Person Affected</option>
                                <option>Corporate Officer or Designated Employee</option>
                            </select>
                        </div>
                    </div>

                </p-accordionTab>
                <p-accordionTab header="E-file Documents">
                    <div *ngIf="myEFileDocs?.length > 0" class="container container-data-entry">
                        <table class="table" style="width: 80%;">
                            <tr style="font-size: smaller">
                                <th *ngFor="let col of cols" style="width: 30%">
                                    {{col.header}}
                                </th>
                                <th></th>
                            </tr>
                    
                            <tr *ngFor="let doc1 of myEFileDocs" style="font-size: small">
                                <td>{{doc1.typeOfDocument[0]?.name}}</td>
                                <td>{{doc1.description}}</td>
                                <td><button id="viewBtn" type="button" class="btn btn-link btn-sm" (click)="viewEfileDoc(doc1.url)">View</button></td>
                            </tr>
                        </table>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="Payment">
                    <div *ngIf="paymentList?.length > 0" class="container container-data-entry">
                        <p-table #efilePayments [columns]="payCols" [value]="paymentList" [responsive]="true" [scrollable]="true" scrollHeight="450px">
                            <ng-template pTemplate="caption">
                                <strong>E-File Application Payments</strong>
                            </ng-template>
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let col of payCols" style="width: 30%">
                                        {{col.header}}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-payment>
                                <tr>
                                    <td>{{ payment.paymentDate | date:"MM/dd/yyyy" }}</td>
                                    <td>{{ payment.appliedAmount | currency }}</td>
                                    <td>{{ payment.username}}</td>
                                    <td>{{ payment.transactionId }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
</div>
